/* eslint-disable jsx-a11y/img-redundant-alt, import/extensions */
/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { object, shape } from "prop-types";

import { getCollectionTemplate } from "../get-collection-template";
import { LazyCollection, LazyLoadImages } from "@quintype/components";
// import { Collection } from "@quintype/components";
import {Helmet} from "react-helmet";

class HomePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: null
    };
  }
  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    this.isWidthPresent();
  }

  lazyAfterValue() {
    if (global.width > 1440) {
      return 2;
    } else if ((global.width > 992 && global.width < 1439) || global.width < 400) {
      return 1;
    }
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <meta name="atdlayout" content="home"/>
        </Helmet>
        <LazyLoadImages>
          <LazyCollection
            collection={this.props.data.collection}
            horoscopeCollection={this.props.data.horoscopeCollection}
            collectionTemplates={getCollectionTemplate}
            lazyAfter={9}
          />
        </LazyLoadImages>
        {/* <Collection
          collection={this.props.data.collection}
          horoscopeCollection={this.props.data.horoscopeCollection}
          collectionTemplates={getCollectionTemplate}
        /> */}
      </React.Fragment>
    );
  }
}

HomePage.propTypes = {
  data: shape({
    collection: object
  })
};

export { HomePage };
